export default "__VITE_ASSET__SDYUysV0__"